import React from 'react';
import { Box, TextField, Button, Typography, Paper } from '@mui/material';
import {CircularProgress} from '@mui/material';
const AppointmentForm = ({ formData, handleFormChange, handleFormSubmit,loading}) => {

  return (
    <Box sx={{ padding: 3, display: 'flex', justifyContent: 'center' }}>
      <Paper elevation={3} sx={{ padding: 4, width: '100%', maxWidth: '400px' }}>
        <Typography variant="h5" sx={{ marginBottom: 2, textAlign: 'center' }}>
          Appointment Details
        </Typography>

        <form onSubmit={handleFormSubmit}>
          <TextField
            fullWidth
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleFormChange}
            sx={{ marginBottom: 2 }}
            required
          />
          <TextField
            fullWidth
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleFormChange}
            sx={{ marginBottom: 2 }}
            required
            type="email"
          />
          <TextField
            fullWidth
            label="Mobile Number"
            name="mobile"
            value={formData.mobile}
            onChange={handleFormChange}
            sx={{ marginBottom: 2 }}
            required
            type="tel"
          />
          <Button
            variant="contained"
            type="submit"
            sx={{
              width: '100%',
              padding: '10px',
              backgroundColor: '#1976d2',
              '&:hover': {
                backgroundColor: '#1565c0',
              },
            }}
          >
                {loading ? (
              <CircularProgress size={24} sx={{ color: "white" }} />
          ) : (
              "Submit"
          )}

          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default AppointmentForm;
